import { ObjectUpdate } from '../../../concepts/objects';
import { ColorList } from '../../../ui';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { QuickCreateInfo } from '../../canvas/tooling/QuickCreateInfo';
import { ToolSettings } from '../../canvas/tooling/ToolBehavior';
import { Sticky } from './Sticky';

class CreateStickyToolBehavior extends CreatePhysicalToolBehavior2(Sticky) {

    public init(settings: ToolSettings, param: string) {
        param = param || 'plop:edit';

        // Set QuickCreateInfo to be Sticky, current user and chosen colour so double clicking repeats the settings.
        if (settings.color) {
            this.session.update(QuickCreateInfo, {
                type: Sticky,
                sets: { background: settings.color },
            });
        }

        return super.init(settings, param);
    }

    protected shouldForceSnap(): boolean {
        return false;
    }

    protected createSubject(u: ObjectUpdate) {
        const sticky = super.createSubject(u);
        if (this.settings.blend) sticky.blend = this.settings.blend;
        sticky.background = this.settings.color ?? ColorList[11];
        if (this.settings.large) {
            sticky.width = 250;
        }
        return sticky;
    }
}

export const stickyTool = defineToolWithCommonBehaviors({
    id: 'stickyTool',
    label: 'Sticky Notes',
    category: 'collaboration',
    icon: 'deqo://icons/d2/sticky',
    weight: 1010,
    shortcut: 'N',
    behaviors: [
        CreateStickyToolBehavior,
    ]
});
